
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.957 14l-.41-9.52s-.665.563-1.996.563-1.996-.563-1.996-.563L5.146 14h4.811zM9.223 3.15h1.808S8.831 4.736 7.5 4.736 3.969 3.15 3.969 3.15h1.808c.588.283 1.218.511 1.723.511.505 0 1.135-.228 1.723-.511zm0-1.131h1.808S8.831 3.605 7.5 3.605 3.969 2.019 3.969 2.019h1.808c.588.283 1.218.512 1.723.512.505 0 1.135-.229 1.723-.512zM11.031.891S8.831 2.478 7.5 2.478 3.969.891 3.969.891h7.062z"}})])
          )
        }
      }
    